import { render, staticRenderFns } from "./ListaFluxo.vue?vue&type=template&id=3ca47866&"
import script from "./ListaFluxo.vue?vue&type=script&lang=js&"
export * from "./ListaFluxo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports